import { ArrowDown, ArrowUp, ArrowUpDown, Clock } from "lucide-react";
import React from "react";
import { SortDirection, SortKey } from "./types";

interface TrackListHeaderProps {
  showAlbum?: boolean;
  showFileSize?: boolean;
  sortKey: SortKey;
  sortDirection: SortDirection;
  onSort: (key: SortKey) => void;
  hideColumn?: boolean;
}

export const TrackListHeader: React.FC<TrackListHeaderProps> = ({
  showAlbum = true,
  showFileSize = false,
  sortKey,
  sortDirection,
  onSort,
  hideColumn = false,
}) => {
  const SortIcon = ({ column }: { column: SortKey }) => {
    if (sortKey !== column) return <ArrowUpDown className="w-4 h-4 opacity-0 group-hover:opacity-50" />;
    return sortDirection === "asc" ? (
      <ArrowUp className="w-4 h-4 text-yellow-500" />
    ) : (
      <ArrowDown className="w-4 h-4 text-yellow-500" />
    );
  };

  const HeaderCell = ({ column, label }: { column: SortKey; label: string | JSX.Element }) => (
    <button
      onClick={() => onSort(column)}
      className={`flex items-center gap-2 group hover:text-white transition-colors ${
        sortKey === column ? "text-white" : "text-zinc-400"
      }`}
    >
      {label}
      <SortIcon column={column} />
    </button>
  );

  return (
    <div className="flex items-center px-4 py-2 border-b border-zinc-700 text-sm sticky top-0 bg-zinc-900/95 backdrop-blur-sm z-10 text-zinc-400">
      <div className="w-[21px] mr-[12px] lg:mr-[18px] text-center block">#</div>
      <div className="flex-1 min-w-[150px] md:min-w-[200px] w-[200px]">
        <HeaderCell column="title" label="TITLE" />
      </div>
      <div className="w-[200px] hidden lg:block">
        <HeaderCell column="artist" label="ARTIST" />
      </div>
      {showAlbum && hideColumn && (
        <div className="w-[200px] hidden lg:block">
          <HeaderCell column="album" label="ALBUM" />
        </div>
      )}
      {showFileSize && hideColumn && (
        <div className="w-[100px] hidden lg:block text-right">
          <HeaderCell column="size" label="SIZE" />
        </div>
      )}
      <div className="w-[100px] flex items-center justify-start pl-5">
        <HeaderCell column="duration" label={<Clock className="w-4 h-4" />} />
      </div>
    </div>
  );
};
